import {http} from '../../plugins/http';

export default {
    show() {
       return http.get(`/api/v1/timers/general-work-timer/show`);
    },

    start() {
        return http.post(`/api/v1/timers/general-work-timer/start`);
    },

    stop() {
       return http.patch(`/api/v1/timers/general-work-timer/stop`);
    },
};



// WEBPACK FOOTER //
// ./src/services/Timers/GeneralWorkTimerController.js